<template>
  <router-link
    to="/kds-stations"
    class="card mx-3 mt-3 mb-3 text-decoration-none text-reset"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-kitchen-set me-2 text-warning" />
          {{ $t('KDS Stations') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ $t('Split kitchen displays by food category, per branch.') }}
        </div>
      </div>
      <i class="fa-solid fa-chevron-right text-muted" />
    </div>
  </router-link>
</template>

<script lang="js">
export default {
  name: 'KdsStationsSettingsCard'
};
</script>
